import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import { format } from "date-fns";

import DatePickerField from "components/lib/Shared/DatePickerField";
import Button from "components/lib/Shared/Button";
import Checkbox from "components/lib/Shared/Checkbox";
import Radio from "components/lib/Shared/Radio";
import { Roles_Permissions_Constants } from "config/roles-permissions";
import Tabs from "../../Tabs";
import { useSelector } from "react-redux";

const DASHBOARD_PERMISSIONS = Roles_Permissions_Constants.DASHBOARD_PERMISSIONS;
const DOCUMENT_PERMISSIONS = Roles_Permissions_Constants.DOCUMENT_PERMISSIONS;
const DASHBOARD_ROLES = Roles_Permissions_Constants.DASHBOARD_ROLES;
const ORG_ADMIN_ROLES = Roles_Permissions_Constants.ORG_ADMIN_ROLES;
const BRS_OPS_ROLES = Roles_Permissions_Constants.BRS_OPS_ROLES;
const SUPER_ADMIN_ROLES = Roles_Permissions_Constants.SUPER_ADMIN_ROLES;
const BILLING_ROLES = Roles_Permissions_Constants.BILLING_ROLES;
const DASHBOARD_PERMISSIONS_AGAINST_ROLES =
  Roles_Permissions_Constants.DASHBOARD_PERMISSIONS_AGAINST_ROLES;

const standardUserRoles = [
  {
    name: DASHBOARD_ROLES.VOR,
    label: "VOR",
    isDefault: false,
  },
  {
    name: DASHBOARD_ROLES.UPLOADER,
    label: "Uploader",
    isDefault: false,
  },
  {
    name: DASHBOARD_ROLES.REVIEWER,
    label: "Reviewer",
    isDefault: false,
  },
  {
    name: DASHBOARD_ROLES.APPROVER,
    label: "Approver",
    isDefault: false,
  },
  {
    name: DASHBOARD_ROLES.REGISTRAR,
    label: "Registrar",
    isDefault: false,
  },
];

const orgAdminRoles = [
  {
    name: ORG_ADMIN_ROLES.UPLOADER,
    label: "Uploader",
    isDefault: false,
  },
  {
    name: ORG_ADMIN_ROLES.REVIEWER,
    label: "Reviewer",
    isDefault: false,
  },
  {
    name: ORG_ADMIN_ROLES.APPROVER,
    label: "Approver",
    isDefault: false,
  },
];

const brsOpsRoles = [
  {
    name: BRS_OPS_ROLES.UPLOADER,
    label: "Uploader",
    isDefault: false,
  },
  {
    name: BRS_OPS_ROLES.REVIEWER,
    label: "Reviewer",
    isDefault: false,
  },
  {
    name: BRS_OPS_ROLES.APPROVER,
    label: "Approver",
    isDefault: false,
  },
];

const superAdminRoles = [
  {
    name: SUPER_ADMIN_ROLES.UPLOADER,
    label: "Uploader",
    isDefault: false,
  },
  {
    name: SUPER_ADMIN_ROLES.REVIEWER,
    label: "Reviewer",
    isDefault: false,
  },
  {
    name: SUPER_ADMIN_ROLES.APPROVER,
    label: "Approver",
    isDefault: false,
  },
];

const billingRoles = [
  {
    name: BILLING_ROLES.UPLOADER,
    label: "Uploader",
    isDefault: false,
  },
  {
    name: BILLING_ROLES.REVIEWER,
    label: "Reviewer",
    isDefault: false,
  },
  {
    name: BILLING_ROLES.APPROVER,
    label: "Approver",
    isDefault: false,
  },
];

let dataPermissions = [
  {
    name: DASHBOARD_PERMISSIONS.VIEW_OWN_DATA,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.VIEW_OWN_DATA
    ),
  },
  {
    name: DASHBOARD_PERMISSIONS.EDIT_OWN_DATA,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.EDIT_OWN_DATA
    ),
  },
  {
    name: DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.VIEW_RESTRICTED_DATA
    ),
  },
  {
    name: DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.EDIT_OTHER_DATA
    ),
  },
  {
    name: DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.REVIEW_TRANSACTIONS
    ),
  },
  {
    name: DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.APPROVE_TRANSACTIONS
    ),
  },
  // {
  //   name: DASHBOARD_PERMISSIONS.MINUTE_BOOK,
  //   label: "Minute Book",
  // },
  {
    name: DASHBOARD_PERMISSIONS.MANAGE_USERS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DASHBOARD_PERMISSIONS.MANAGE_USERS
    ),
  },
];

let documentPermissions = [
  {
    name: DOCUMENT_PERMISSIONS.STATUTORY_RECORDS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.STATUTORY_RECORDS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.DIRECTOR_RESOLUTIONS_AND_CONSENTS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.DIRECTOR_RESOLUTIONS_AND_CONSENTS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.SHAREHOLDER_RESOLUTIONS_AND_CONSENTS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.SHAREHOLDER_RESOLUTIONS_AND_CONSENTS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_DIRECTORS_AND_SECRETARIES,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_DIRECTORS_AND_SECRETARIES
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_DIRECTORS_AND_SECRETARIES_RESIDENCES,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_DIRECTORS_AND_SECRETARIES_RESIDENCES
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_MEMBERS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_MEMBERS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_APPLICATIONS_AND_ALLOTMENTS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_APPLICATIONS_AND_ALLOTMENTS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_TRANSFERS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_TRANSFERS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_CHARGES_MORTGAGES,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_CHARGES_MORTGAGES
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.REGISTER_OF_DEBENTURES,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_DEBENTURES
    ),
  },
  {
    name: DASHBOARD_PERMISSIONS.REGISTER_OF_BENEFICIAL_OWNERS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.REGISTER_OF_BENEFICIAL_OWNERS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.SHARE_CERTIFICATES,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.SHARE_CERTIFICATES
    ),
  },

  {
    name: DOCUMENT_PERMISSIONS.AGREEMENTS_AND_CONTRACTS,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.AGREEMENTS_AND_CONTRACTS
    ),
  },
  {
    name: DOCUMENT_PERMISSIONS.POLICIES,
    label: Roles_Permissions_Constants.getPermissionLabel(
      DOCUMENT_PERMISSIONS.POLICIES
    ),
  },
];

const AssignPermissionsSelection = ({
  initialValues,
  submitBtnLabel,
  loadingText,
  handleSubmit,
  permissionsToBeRequested,
  hasRoles,
  setFieldValueToParent,
  employCreateWorkflow = false,
  forEmployee = false,
  handleDelete = () => null,
}) => {
  let toBeRequestedDataPermissions;
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [showOrgAdminRoles, setShowOrgAdminRoles] = useState(false);
  const [roles, setRoles] = useState(standardUserRoles);
  let defaultTabs = [
    {
      label: "Standard User",
      id: "standardUser",
    },
    {
      label: "Org Admin",
      id: "orgAdmin",
    },
  ];
  const [tabs, setTabs] = useState(defaultTabs);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const { organization } = useSelector((state) => state.organizationsSlice);

  if (permissionsToBeRequested && Array.isArray(permissionsToBeRequested)) {
    const documentPermissionValues = Object.values(DOCUMENT_PERMISSIONS);
    const hasDocumentPermissions = permissionsToBeRequested.some(
      (docPermission) => documentPermissionValues.includes(docPermission.name)
    );
    const toBeRequestedDocPermissions =
      (hasDocumentPermissions &&
        permissionsToBeRequested.filter((docPermission) =>
          documentPermissionValues.includes(docPermission.name)
        )) ||
      [];
    toBeRequestedDataPermissions =
      (permissionsToBeRequested &&
        permissionsToBeRequested.filter(
          (docPermission) =>
            !documentPermissionValues.includes(docPermission.name)
        )) ||
      [];

    hasDocumentPermissions
      ? (documentPermissions = toBeRequestedDocPermissions)
      : (documentPermissions = []);
  }

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex]);

  useEffect(() => {
    if (organization?.status === "Active") {
      setShowOrgAdminRoles(true);
      if (organization?.isOrgAdmin) {
        setTabs([
          ...defaultTabs,
          {
            label: "Brs Ops",
            id: "brsOps",
          },
          {
            label: "Billing",
            id: "billing",
          },
        ]);
      } else {
        {
          setTabs([
            ...defaultTabs,
            {
              label: "Super Admin",
              id: "superAdmin",
            },
            {
              label: "Billing",
              id: "billing",
            },
          ]);
        }
      }
    }
  }, [organization]);

  useEffect(() => {
    switch (selectedTab.id) {
      case "standardUser":
        setRoles(standardUserRoles);
        break;
      case "orgAdmin":
        setRoles(orgAdminRoles);
        break;
      case "brsOps":
        setRoles(brsOpsRoles);
        break;
      case "superAdmin":
        setRoles(superAdminRoles);
        break;
      case "billing":
        setRoles(billingRoles);
        break;
      default:
        setRoles(standardUserRoles);
        break;
    }
  }, [selectedTab]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, isSubmitting, setFieldValue }) => {
        const { dashboardPermissions, dashboardRoles } = values;
        useEffect(() => {
          if (employCreateWorkflow) {
            setFieldValueToParent(
              "dashboardRoles",
              values.dashboardRoles.map((role) => ({
                ...role,
                isDefault: true,
              }))
            );
            setFieldValueToParent(
              "dashboardPermissions",
              values.dashboardPermissions.map((permission) => ({
                ...permission,
                isDefault: true,
              }))
            );
            setFieldValueToParent("accessType", values.accessType);
            if (
              values["accessType"][selectedTab.id]["duration"] === "timeBound"
            ) {
              setFieldValueToParent(
                `accessType.${selectedTab.id}.startDate`,
                values["accessType"][selectedTab.id]["startDate"]
              );
              setFieldValueToParent(
                `accessType.${selectedTab.id}.endDate`,
                values["accessType"][selectedTab.id]["endDate"]
              );
            }
          }
        }, [
          values.dashboardPermissions,
          values.dashboardRoles,
          values.accessType,
          values["accessType"][selectedTab.id]["startDate"],
          values["accessType"][selectedTab.id]["endDate"],
        ]);

        const disableRolesField = dashboardRoles.filter((role) => {
          if (role.isDefault) {
            return role.name;
          }
        });
        const handleDateValue = (type) => (date) => {
          setFieldValue(type, format(date, "yyyy/MM/dd"));
        };

        const handleToggleSelectAllPermissions = (e, permissions, name) => {
          const fieldName = "dashboardPermissions";
          const isChecked = e.target.checked;
          const permissionNames = permissions.map(
            (permission) => permission.name
          );

          if (isChecked) {
            const newPermissions = permissionNames.map((name) => ({
              name,
              isDefault: false,
            }));
            const updatedPermissions = [
              ...values[fieldName],
              ...newPermissions,
            ];

            // Remove duplicates based on the permission name
            const uniquePermissions = Array.from(
              new Map(
                updatedPermissions.map((permission) => [
                  permission.name,
                  permission,
                ])
              ).values()
            );

            setFieldValue(fieldName, uniquePermissions);
          } else {
            if (name === "documents") {
              const remainingPermissions = values[fieldName].filter(
                (permission) => !permissionNames.includes(permission.name)
              );
              setFieldValue(fieldName, remainingPermissions);
            }
            if (name === "data") {
              const selectedRolesPermissions = dashboardRoles
                .map((role) => DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name])
                .flat()
                .map((name) => ({
                  name,
                  isDefault: true,
                }));

              const remainingPermissions = values[fieldName].filter(
                (permission) => !permissionNames.includes(permission.name)
              );

              const updatedPermissions = [
                ...selectedRolesPermissions,
                ...remainingPermissions,
              ];

              // Remove duplicates based on the permission name
              const uniquePermissions = Array.from(
                new Map(
                  updatedPermissions.map((permission) => [
                    permission.name,
                    permission,
                  ])
                ).values()
              );

              setFieldValue(fieldName, uniquePermissions);
            }
          }
        };

        const handleToggleSelectAllRoles = (e) => {
          const isChecked = e.target.checked;
          if (isChecked) {
            let allActiveRoles = roles.filter(
              (role) =>
                !disableRolesField.some(
                  (disabledRole) => disabledRole.name === role.name
                )
            );

            if (selectedTab.id === "standardUser") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !standardUserRoles.some(
                    (orgRole) => orgRole.name === role.name
                  )
              );
              let nonDisabledRoles = standardUserRoles.filter(
                (role) =>
                  !disableRolesField.some(
                    (disabledRole) => disabledRole.name === role.name
                  )
              );
              allActiveRoles = [...otherRoles, ...nonDisabledRoles];
            }

            if (selectedTab.id === "orgAdmin") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !orgAdminRoles.some((orgRole) => orgRole.name === role.name)
              );
              let nonDisabledRoles = orgAdminRoles.filter(
                (role) =>
                  !disableRolesField.some(
                    (disabledRole) => disabledRole.name === role.name
                  )
              );
              allActiveRoles = [...otherRoles, ...nonDisabledRoles];
            }

            if (selectedTab.id === "brsOps") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !brsOpsRoles.some((orgRole) => orgRole.name === role.name)
              );
              let nonDisabledRoles = brsOpsRoles.filter(
                (role) =>
                  !disableRolesField.some(
                    (disabledRole) => disabledRole.name === role.name
                  )
              );
              allActiveRoles = [...otherRoles, ...nonDisabledRoles];
            }

            if (selectedTab.id === "superAdmin") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !superAdminRoles.some((orgRole) => orgRole.name === role.name)
              );
              let nonDisabledRoles = superAdminRoles.filter(
                (role) =>
                  !disableRolesField.some(
                    (disabledRole) => disabledRole.name === role.name
                  )
              );
              allActiveRoles = [...otherRoles, ...nonDisabledRoles];
            }

            if (selectedTab.id === "billing") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !billingRoles.some((orgRole) => orgRole.name === role.name)
              );
              let nonDisabledRoles = billingRoles.filter(
                (role) =>
                  !disableRolesField.some(
                    (disabledRole) => disabledRole.name === role.name
                  )
              );
              allActiveRoles = [...otherRoles, ...nonDisabledRoles];
            }

            const permissionsAgainstAllRoles = roles
              .flatMap(
                (role) => DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name] || []
              )
              .map((permission) => ({ name: permission, isDefault: false }));

            const allPermissions = [
              ...permissionsAgainstAllRoles,
              ...dashboardPermissions,
            ];
            const uniquePermissions = Array.from(
              new Map(
                allPermissions.map((permission) => [
                  permission.name,
                  permission,
                ])
              ).values()
            );

            setFieldValue("dashboardRoles", [
              ...allActiveRoles,
              ...disableRolesField,
            ]);

            setFieldValue("dashboardPermissions", uniquePermissions);
          } else {
            let allActiveRoles = [];
            if (selectedTab.id === "standardUser") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !standardUserRoles.some(
                    (orgRole) => orgRole.name === role.name
                  )
              );
              allActiveRoles = [...otherRoles];
            }

            if (selectedTab.id === "orgAdmin") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !orgAdminRoles.some((orgRole) => orgRole.name === role.name)
              );
              allActiveRoles = [...otherRoles];
            }

            if (selectedTab.id === "brsOps") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !brsOpsRoles.some((orgRole) => orgRole.name === role.name)
              );
              allActiveRoles = [...otherRoles];
            }

            if (selectedTab.id === "superAdmin") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !superAdminRoles.some((orgRole) => orgRole.name === role.name)
              );
              allActiveRoles = [...otherRoles];
            }

            if (selectedTab.id === "billing") {
              let otherRoles = dashboardRoles.filter(
                (role) =>
                  !billingRoles.some((orgRole) => orgRole.name === role.name)
              );
              allActiveRoles = [...otherRoles];
            }

            setFieldValue("dashboardRoles", [
              ...allActiveRoles,
              ...disableRolesField,
            ]);

            const disableRolePermissions = disableRolesField
              .flatMap(
                (role) => DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name] || []
              )
              .map((permission) => ({ name: permission, isDefault: true }));

            const uniqueDisableRolePermissions = Array.from(
              new Map(
                disableRolePermissions.map((permission) => [
                  permission.name,
                  permission,
                ])
              ).values()
            );

            setFieldValue("dashboardPermissions", uniqueDisableRolePermissions);
          }
        };

        const handleToggleRole = (e) => {
          const roleName = e.target.value;
          const isChecked = e.target.checked;

          if (isChecked) {
            setFieldValue("dashboardRoles", [
              ...dashboardRoles,
              { name: roleName, isDefault: false },
            ]);

            if (selectedTab.id === "standardUser") {
              // Collect permissions from all roles
              let selectedPermissions = new Set();
              selectedPermissions = dashboardRoles
                .flatMap(
                  (role) => DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name] || []
                )
                .map((permission) => ({ name: permission, isDefault: false }));

              selectedPermissions = [
                ...DASHBOARD_PERMISSIONS_AGAINST_ROLES[roleName].map(
                  (permission) => ({ name: permission, isDefault: false })
                ),
                ...dashboardPermissions,
              ];

              const permissionsMap = new Map();
              selectedPermissions.forEach((permission) => {
                if (!permissionsMap.has(permission.name)) {
                  permissionsMap.set(permission.name, permission);
                } else {
                  const existingPermission = permissionsMap.get(
                    permission.name
                  );
                  permissionsMap.set(permission.name, {
                    ...existingPermission,
                    isDefault: existingPermission.isDefault,
                  });
                }
              });

              // Preserve the isDefault status of existing dashboardPermissions
              dashboardPermissions.forEach((permission) => {
                if (permissionsMap.has(permission.name)) {
                  const existingPermission = permissionsMap.get(
                    permission.name
                  );
                  permissionsMap.set(permission.name, {
                    ...existingPermission,
                    isDefault: permission.isDefault,
                  });
                }
              });

              setFieldValue(
                "dashboardPermissions",
                Array.from(permissionsMap.values())
              );
            }
          } else {
            const updatedDashboardRoles = dashboardRoles.filter(
              (role) => role.name !== roleName
            );

            const unselectedRolePermissions =
              DASHBOARD_PERMISSIONS_AGAINST_ROLES[roleName] || [];

            // Find permissions that are still needed by other selected roles
            let stillRequiredPermissions = new Set();
            updatedDashboardRoles.forEach((role) => {
              (DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name] || []).forEach(
                (permission) => {
                  stillRequiredPermissions.add(permission);
                }
              );
            });

            const permissionsWithoutUnselectedRolePermissions =
              dashboardPermissions.filter(
                (permission) =>
                  stillRequiredPermissions.has(permission.name) ||
                  !unselectedRolePermissions.includes(permission.name)
              );

            setFieldValue("dashboardRoles", updatedDashboardRoles);

            if (selectedTab.id === "standardUser") {
              let selectedPermissions = new Set();
              selectedPermissions = updatedDashboardRoles
                .flatMap(
                  (role) => DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name] || []
                )
                .map((permission) => ({ name: permission, isDefault: false }));

              selectedPermissions = [
                ...selectedPermissions,
                ...permissionsWithoutUnselectedRolePermissions,
              ];

              const permissionsMap = new Map();
              selectedPermissions.forEach((permission) => {
                if (!permissionsMap.has(permission.name)) {
                  permissionsMap.set(permission.name, permission);
                } else {
                  const existingPermission = permissionsMap.get(
                    permission.name
                  );
                  permissionsMap.set(permission.name, {
                    ...existingPermission,
                    isDefault: existingPermission.isDefault,
                  });
                }
              });

              // Preserve the isDefault status of existing dashboardPermissions
              permissionsWithoutUnselectedRolePermissions.forEach(
                (permission) => {
                  if (permissionsMap.has(permission.name)) {
                    const existingPermission = permissionsMap.get(
                      permission.name
                    );
                    permissionsMap.set(permission.name, {
                      ...existingPermission,
                      isDefault: permission.isDefault,
                    });
                  }
                }
              );

              setFieldValue(
                "dashboardPermissions",
                Array.from(permissionsMap.values())
              );
            }
          }
        };

        const handleTogglePermission = (e) => {
          const permissionName = e.target.value;
          const isChecked = e.target.checked;
          if (isChecked) {
            setFieldValue("dashboardPermissions", [
              ...dashboardPermissions,
              { name: permissionName, isDefault: false },
            ]);
          } else {
            setFieldValue(
              "dashboardPermissions",
              dashboardPermissions.filter(
                (permission) => permission.name !== permissionName
              )
            );
          }
        };

        const isPermissionInSelectedRoles = (permission) => {
          return dashboardRoles.some((role) => {
            const rolePermissions =
              DASHBOARD_PERMISSIONS_AGAINST_ROLES[role.name];
            return rolePermissions && rolePermissions.includes(permission);
          });
        };

        return (
          <Form>
            <div className="flex flex-col space-y-2 my-2">
              {showOrgAdminRoles && (
                <Tabs
                  tabs={tabs}
                  selectedTabIndex={selectedTabIndex}
                  setSelectedTabIndex={setSelectedTabIndex}
                />
              )}

              {hasRoles && (
                <div className="bg-white p-4 space-y-2 rounded-sm shadow-sm sm:rounded md:rounded-md">
                  <div className="flex justify-between items-center">
                    <p className="text-gray-700 font-semibold">Roles</p>
                    <Checkbox
                      name="selectAll"
                      label="Select All"
                      checked={roles.every((role) =>
                        dashboardRoles.some(
                          (selectedRole) => selectedRole.name === role.name
                        )
                      )}
                      disabled={roles.length === 0}
                      onChange={handleToggleSelectAllRoles}
                    />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3">
                    {roles.map((checkboxParams) => (
                      <Checkbox
                        key={checkboxParams.name}
                        {...checkboxParams}
                        checked={dashboardRoles.some(
                          (role) => role.name === checkboxParams.name
                        )}
                        // disabled={
                        //   // isSubmitting ||
                        //   // disableRolesField.some(
                        //   //   (role) => role.name === checkboxParams.name
                        //   // )
                        // }
                        onChange={handleToggleRole}
                      />
                    ))}
                  </div>
                </div>
              )}
              {selectedTab.id === "standardUser" && (
                <>
                  {permissionsToBeRequested ? (
                    <div className="bg-white p-4 space-y-2 rounded-sm shadow-sm sm:rounded md:rounded-md">
                      <div className="flex justify-between items-center">
                        <p className="text-gray-700 font-semibold">
                          Permissions
                        </p>
                        <Checkbox
                          name="selectAllPermissions"
                          label="Select All"
                          checked={toBeRequestedDataPermissions?.every(
                            (permission) =>
                              values.dashboardPermissions.some(
                                (permissionName) =>
                                  permissionName.name === permission.name
                              )
                          )}
                          disabled={
                            isSubmitting ||
                            toBeRequestedDataPermissions.length === 0
                          }
                          onChange={(e) =>
                            handleToggleSelectAllPermissions(
                              e,
                              toBeRequestedDataPermissions,
                              "data"
                            )
                          }
                        />
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3">
                        {toBeRequestedDataPermissions.map((checkboxParams) => (
                          <Checkbox
                            key={checkboxParams}
                            {...checkboxParams}
                            checked={
                              dashboardPermissions.some(
                                (permission) =>
                                  permission.name === checkboxParams.name
                              ) || checkboxParams?.isDefault
                            }
                            disabled={
                              isSubmitting ||
                              isPermissionInSelectedRoles(
                                checkboxParams.name
                              ) ||
                              checkboxParams?.isDefault
                            }
                            onChange={handleTogglePermission}
                          />
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="bg-white p-4 space-y-2 rounded-sm shadow-sm sm:rounded md:rounded-md">
                      <div className="flex justify-between items-center">
                        <p className="text-gray-700 font-semibold">
                          Permissions
                        </p>
                        <Checkbox
                          name="selectAllPermissions"
                          label="Select All"
                          checked={dataPermissions.every((permission) =>
                            values.dashboardPermissions.some(
                              (permissionName) =>
                                permissionName.name === permission.name
                            )
                          )}
                          disabled={
                            isSubmitting || dataPermissions.length === 0
                          }
                          onChange={(e) =>
                            handleToggleSelectAllPermissions(
                              e,
                              dataPermissions,
                              "data"
                            )
                          }
                        />
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3">
                        {dataPermissions.map((checkboxParams) => (
                          <Checkbox
                            key={checkboxParams}
                            {...checkboxParams}
                            checked={
                              dashboardPermissions.some(
                                (permission) =>
                                  permission.name === checkboxParams.name
                              ) ||
                              isPermissionInSelectedRoles(checkboxParams.name)
                            }
                            disabled={
                              isSubmitting ||
                              isPermissionInSelectedRoles(checkboxParams.name)
                            }
                            onChange={handleTogglePermission}
                          />
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="bg-white p-4 space-y-2 rounded-sm shadow-sm sm:rounded md:rounded-md">
                    <div className="flex justify-between items-center">
                      <p className="text-gray-700 font-semibold">Documents</p>
                      <Checkbox
                        name="selectAllPermissions"
                        label="Select All"
                        checked={documentPermissions.every((permission) =>
                          values.dashboardPermissions.some(
                            (permissionName) =>
                              permissionName.name === permission.name
                          )
                        )}
                        disabled={
                          isSubmitting || documentPermissions.length === 0
                        }
                        onChange={(e) =>
                          handleToggleSelectAllPermissions(
                            e,
                            documentPermissions,
                            "documents"
                          )
                        }
                      />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 ">
                      {documentPermissions.map((checkboxParams) => (
                        <Checkbox
                          key={checkboxParams.name}
                          {...checkboxParams}
                          checked={dashboardPermissions.some(
                            (permission) =>
                              permission.name === checkboxParams.name
                          )}
                          disabled={
                            isSubmitting ||
                            isPermissionInSelectedRoles(checkboxParams.name)
                          }
                          onChange={handleTogglePermission}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
            <hr />
            <div className="flex space-x-16 my-4">
              <Radio
                name={`accessType.${[selectedTab.id]}.${["duration"]}`}
                id={`accessType.${[selectedTab.id]}.${["duration"]}`}
                label="Time Bound"
                value="timeBound"
                disabled={isSubmitting}
              />
              <Radio
                name={`accessType.${[selectedTab.id]}.${["duration"]}`}
                id={`accessType.${[selectedTab.id]}.${["duration"]}`}
                label="Indefinite"
                value="indefinite"
                disabled={isSubmitting}
              />
            </div>
            {values["accessType"][selectedTab.id]["duration"] ===
              "timeBound" && (
              <div className="flex space-x-2">
                <div className="flex flex-col grow">
                  <Field
                    name={`accessType.${selectedTab.id}.startDate`}
                    label="Start date"
                    id={`accessType.${selectedTab.id}.startDate`}
                    component={DatePickerField}
                    disabled={isSubmitting}
                    onChange={handleDateValue(
                      `${`accessType.${selectedTab.id}.startDate`}`
                    )}
                    onSelect={handleDateValue(
                      `${`accessType.${selectedTab.id}.startDate`}`
                    )}
                    selected={
                      values?.accessType?.[selectedTab.id]?.startDate
                        ? new Date(values.accessType[selectedTab.id].startDate)
                        : null
                    }
                    minDate={new Date()}
                    placeholderText="Select start date"
                    errorPath={`accessType.${selectedTab.id}.startDate`}
                  />
                </div>
                <div className="flex flex-col grow">
                  <Field
                    name={`accessType.${selectedTab.id}.endDate`}
                    label="End date"
                    id={`accessType.${selectedTab.id}.endDate`}
                    component={DatePickerField}
                    disabled={isSubmitting}
                    onChange={handleDateValue(
                      `${`accessType.${selectedTab.id}.endDate`}`
                    )}
                    onSelect={handleDateValue(
                      `${`accessType.${selectedTab.id}.endDate`}`
                    )}
                    selected={
                      values?.accessType?.[selectedTab.id]?.endDate
                        ? new Date(values.accessType[selectedTab.id].endDate)
                        : null
                    }
                    minDate={new Date()}
                    placeholderText="Select end date"
                    errorPath={`accessType.${selectedTab.id}.endDate`}
                  />
                </div>
              </div>
            )}
            {!employCreateWorkflow && (
              <>
                {forEmployee ? (
                  <div className="flex justify-between my-4">
                    <Button
                      type="button"
                      onClick={() => {
                        handleDelete();
                      }}
                      className="bg-red-500 text-white"
                    >
                      Delete Employee
                    </Button>
                    <Button
                      type="submit"
                      isLoading={isSubmitting}
                      loadingText={loadingText}
                    >
                      {submitBtnLabel}
                    </Button>
                  </div>
                ) : (
                  <div className="flex justify-end my-4">
                    <Button
                      type="submit"
                      isLoading={isSubmitting}
                      loadingText={loadingText}
                    >
                      {submitBtnLabel}
                    </Button>
                  </div>
                )}
              </>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default AssignPermissionsSelection;
